import { API_BASE_URL } from '../../lib/apiBaseUrl';

export const portalApiUrl = (path) => `${API_BASE_URL}${path}`;
